module.exports = __webpack_public_path__ + "media/images/application/template/icon-product-approvals-897a2dead3f9f65efed49ba45ba7ae05.svg";